import React, { useState } from "react"; 
import BaseSimplePage from "../../../Components/Base/BaseSimplePage";
import RotogramaViagemComponent from "./RotogramaViagemComponent";

const RotogramaViagemSimplePage = (props: any) => {
    const [loading, setLoading] = useState(true);
    
    function loadingCallBack(loading: boolean) {
        setLoading(loading);
    }

    return (
        <BaseSimplePage loading={loading}>
            <RotogramaViagemComponent loadingCallBack={loadingCallBack} simplePage={true} />
        </BaseSimplePage>
    );
}

export default RotogramaViagemSimplePage;

